import { render, staticRenderFns } from "./breeders-container.vue?vue&type=template&id=400fe2cb&scoped=true&lang=pug"
import script from "./breeders-container.js?vue&type=script&lang=js&external"
export * from "./breeders-container.js?vue&type=script&lang=js&external"
import style0 from "./breeders-container.vue?vue&type=style&index=0&id=400fe2cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400fe2cb",
  null
  
)

export default component.exports